const layout = {
    appOverlayZindex: 11002,
    appZIndex: 2,
    defaultZIndex: 1,
    menuZIndex: 3,
    proposalItemGridOverlayZIndex: 3,
};

module.exports = layout;
